import { useEffect, useState } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import commonServices from '@/common/services/services'
import routes from '@/Router/routes.constants'

import { pageSize } from './constants'

const useNotifications = ({ updateContext, setToastInfo, navigate, storeId }) => {
  const [page, setPage] = useState(1)
  const [showNotificationsMenu, setShowNotificationsMenu] = useState(false)
  const {
    data: notifications,
    fetchData: getNotifications,
    loading: loadingNotifications,
  } = useFetch(commonServices.getStoreNotifications, {
    doInitialRequest: !!storeId,
    params: { params: { page, page_size: pageSize } },
  })
  const { fetchData: markAllAsRead, loading: loadingMarkAllAsRead } = useFetch(
    commonServices.markAllNotificationsAsRead,
    {
      doInitialRequest: false,
    }
  )
  const { fetchData: markAsRead } = useFetch(commonServices.markNotificationAsRead, {
    doInitialRequest: false,
  })

  useEffect(() => {
    if (storeId && showNotificationsMenu) {
      getNotifications({ params: { page, page_size: pageSize } })
    }

    if (!showNotificationsMenu) {
      setPage(1)
    }
  }, [storeId, page, showNotificationsMenu])

  const handleMarkAllAsRead = async () => {
    try {
      await markAllAsRead()
      updateContext(info => ({
        ...info,
        selectedStore: {
          ...info?.selectedStore,
          num_unread_notifications: 0,
        },
      }))
      setPage(1)
    } catch (error) {
      setToastInfo({ show: true, message: error.errorMessage, type: 'error' })
    }
  }

  const onClickNotification = async notification => {
    setShowNotificationsMenu(false)
    try {
      if (!notification?.read_at) {
        await markAsRead({ notificationId: notification?.id })
        getNotifications({ params: { page, page_size: pageSize } })
        updateContext(info => ({
          ...info,
          selectedStore: {
            ...info?.selectedStore,
            num_unread_notifications: info?.selectedStore?.num_unread_notifications - 1,
          },
        }))
      }
      setPage(1)

      if (notification?.type.includes('invoice')) {
        navigate(routes.billingDetailPage.replace(':id', notification?.properties?.invoice?.id))
      } else {
        navigate(routes.transactionDetailPage.replace(':id', notification?.return?.id))
      }
    } catch (error) {
      setToastInfo({ show: true, message: error.errorMessage, type: 'error' })
    }
  }

  return {
    getNotifications,
    loadingNotifications,
    markAllAsRead,
    loadingMarkAllAsRead,
    markAsRead,
    notificationsPage: page,
    setNotificationsPage: setPage,
    notificationsCountPage: Math.ceil(notifications?.count / pageSize),
    handleMarkAllAsRead,
    notifications,
    showNotificationsMenu,
    setShowNotificationsMenu,
    onClickNotification,
  }
}

export default useNotifications
